




import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Btn from "../../shared/button/Btn"
import { profilKayitliSurucuEkle } from "../../../features/companyProfile/companyProfileSlice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;
    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            padding: 40px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            .info{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                p{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-md);
                }
                span{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-sm);
                }
            }
        }
        .text{
            padding-inline: 40px;
            p{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
            }
        }
        .btn-container{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-block: 30px;
        }
    }
`

const maskName = (name) => {
    const parts = name?.split(' ');
    return parts?.map(part => part[0] + ' * '?.repeat(part.length - 1))?.join(' ');
  };
  
  const maskDate = (date) => {
    if (!date) {
        return null;
    } else {
        const parts = date.split(/[-/]/);
        return '** / ** / ' + parts[2];
    }
};
   
  const maskTCNo = (tcNo) => {
    if(!tcNo) {
        return null
    } else {
        return tcNo?.slice(0, 2) + ' * '?.repeat(tcNo?.length - 4) + tcNo?.slice(-2);
    }
  };



const ProfilSurucuSearchDetailModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const {surucuSorguInfo, isLoadingAddOzvarlik} = useSelector((state) => state.companyProfile)
    
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Sürücü Ara"}/>
        <div className="content">
            <div className="info">
                <p>Telefon Numarası:</p>
                <span>{surucuSorguInfo?.phoneNumber}</span>
            </div>

            <div className="info">
                <p>Ad Soyad:</p>
                <span>{maskName(surucuSorguInfo?.adSoyadUnvan)}</span>
            </div>

            <div className="info">
                <p>Doğum Tarihi:</p>
                <span>{maskDate(surucuSorguInfo?.dogumTarihi)}</span>
            </div>

            <div className="info">
                <p>TC No:</p>
                <span>{maskTCNo(surucuSorguInfo?.tckn)}</span>
            </div>
            <div className="info">
                <p>Ehliyet:</p>
                <span>{surucuSorguInfo?.ehliyetTypes?.$values?.map((item) => (
                    <span>{item?.ehliyet},</span>
                ))}</span>
            </div>

            <div className="info">
                <p>SRC:</p>
                <span>{surucuSorguInfo?.srcTypes?.$values?.map((item) => (
                    <span>{item?.srcBelgesi},</span>
                ))}</span>
            </div>

            <div className="info">
                <p>İl/İlçe:</p>
                <span>{surucuSorguInfo?.il}/{surucuSorguInfo?.ilce}</span>
            </div>

        </div>

        <div className="text">
            <p>
                Yukarıdaki kısıtlı bilgiler kaydetmek istediğiniz sürücüye ait ise sürücü olarak kaydediniz.<br/>Kayıt sonrası Sürücünün Mobilden onay vermesi beklenecektir. Onay sonrası kayıtlı bilgiler gösterilecektir.
            </p>
        </div>

        <div className="btn-container">
            <Btn bgColor={"#E85446"} color={"#fff"} width={"200px"} handleClick={() => dispatch(profilKayitliSurucuEkle({userId: surucuSorguInfo?.id}))} >{isLoadingAddOzvarlik ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Sürücülerime Ekle"}</Btn>
            <Btn bgColor={"transparent"} color={"#E85446"} width={"200px"} handleClick={() => dispatch(showModal(null))} >Kapat</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default ProfilSurucuSearchDetailModal